import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <header className="sticky-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight hover:text-accent transition-colors"
            data-testid="logo-btn"
          >
            COLTURE PLAYBOOK
          </button>
          
          {!isAdminPage && (
            <nav className="flex items-center gap-6">
              <a
                href="#signup-section"
                className="text-sm font-medium uppercase tracking-wider hover:text-accent transition-colors hidden md:block"
                data-testid="nav-signup-link"
              >
                Sign Up
              </a>
              <button
                onClick={() => navigate('/admin')}
                className="text-sm font-medium uppercase tracking-wider hover:text-accent transition-colors"
                data-testid="nav-admin-link"
              >
                Admin
              </button>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;